import { render, staticRenderFns } from "./SpecificationLegacyArticle.vue?vue&type=template&id=97aed47a&scoped=true"
import script from "./SpecificationLegacyArticle.vue?vue&type=script&lang=js"
export * from "./SpecificationLegacyArticle.vue?vue&type=script&lang=js"
import style0 from "./SpecificationLegacyArticle.vue?vue&type=style&index=0&id=97aed47a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97aed47a",
  null
  
)

export default component.exports